export const AssignmentActionTypes = {
  CLOSE: "CLOSE",
  REMOVE: "REMOVE"
};
